const getDayInterval = function (startDate, endDate) {
    let start = new Date(startDate);
    let end = new Date(endDate);
    return 1 + Math.round(
        Math.abs((start.getTime() - end.getTime()) / (24 * 60 * 60 * 1000))
    );
}


const split = function (s, sep) {
    if (s === "" || s === null || s === "undefined") {
        return [];
    }

    return s.split(sep);
}

const apiCall = async function (baseUrl, route, paramMap, method="GET", postJson) {
    let user = firebase.auth().currentUser;
    let token = await user.getIdToken().then((t) => t);

    let fullUrl = baseUrl + route

    if (paramMap && paramMap.size > 0) {
        fullUrl += '?'
        paramMap.forEach((value, key, _) => fullUrl += `${key}=${value}&`)
        fullUrl = fullUrl.slice(0, -1)
    }

    let meta = {}
    if (method === "POST") {
        meta = {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "JWT " + token,
            },
            body: JSON.stringify(postJson),
        }
    }
    else if(method === "DELETE"){
        meta = {
            method: "DELETE",
                headers: {
            Authorization: "JWT " + token,
        },
        }
    }
    else {
        meta = {
            headers: {
                Authorization: "JWT " + token,
            }
        }
    }

    return fetch(fullUrl, meta)
}

const doDatesIncludeToday = function (startDate, endDate) {
    let today = new Date();
    let now =
        today.getFullYear() +
        "-" +
        ("0" + (today.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + today.getDate()).slice(-2);
    return (
        startDate === now ||
        endDate === now ||
        (startDate < now && endDate > now)
    );
}

const getUpdatedDates = function (interval, daysBack) {
    let endDate = new Date();
    endDate.setDate(endDate.getDate() - daysBack);
    let endDateStr =
        endDate.getFullYear() +
        "-" +
        ("0" + (endDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + endDate.getDate()).slice(-2);

    let startDate = new Date();
    startDate.setDate(new Date().getDate() - interval - daysBack);
    let startDateStr =
        startDate.getFullYear() +
        "-" +
        ("0" + (startDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + startDate.getDate()).slice(-2);

    return [startDateStr, endDateStr]
}

export const existsOrDefault = function (obj, def="") {
    if(obj) {
        return obj
    }
    return def
}

const downloadFile = function (fileName, fileData) {
    let url = ""

    if (fileData instanceof Blob) {
        url = window.URL.createObjectURL(fileData);
    }
    else{
        url = 'data:text/plain;charset=utf-8,' + encodeURIComponent(fileData);
    }

    let aLink = document.createElement("a");
    document.body.appendChild(aLink);
    aLink.download = fileName;
    aLink.href = url;

    let event = new MouseEvent("click");
    aLink.dispatchEvent(event);

    if (fileData instanceof Blob) {
        window.URL.revokeObjectURL(url);
    }
}

export default {getDayInterval, split, apiCall, doDatesIncludeToday, getUpdatedDates, existsOrDefault, downloadFile}


// WEBPACK FOOTER //
// ./src/util/util.js